import { UserConstants as Constants } from '../types'

const initialState = {
    users: [],    
    error: null,    
    loading: false   
};

export function userReducer(state = initialState, action) {
    switch (action.type) {  
        case Constants.GET:            
            return {
                ...state,
                users: action?.payload?.users,
                loading: false,
                error: null,
            };

   
            
        case Constants.ADD:
            return {
                ...state,
                users: [...state?.users, action?.payload?.user],
                loading: false,
                error: null,
            }

        case Constants.UPDATE:            
            const index = state.users.findIndex(x => x.id ===  action?.payload?.user?.id)
            const newArray = [...state.users];
            if(index > -1)
                newArray[index] = action?.payload?.user
            return {
                ...state,
                users: newArray,
                loading: false,
                error: null,
            }   

        case Constants.DELETE:
            return{
                ...state,
                users: state?.users?.filter(x => parseInt(x?.id) !== parseInt(action?.payload?.id)),
                loading: false,
                error: null,
            };

        case Constants.REMOVE_DOC:
            const user_index = state.users.findIndex(x => parseInt(x.id) ===  parseInt(action?.payload?.user_id))            
            const all_users = [...state.users];
            if(user_index > -1){
                const user = all_users[user_index]
                let docs = user?.documents?.filter(x => parseInt(x?.id) !== parseInt(action?.payload?.doc_id))
                user['documents'] = docs;
                all_users[user_index] = user
            }
            
            return{
                ...state,
                users: all_users,
                loading: false,
                error: null,
            };
       
        
        case Constants.FAIL:
            return{
                ...state,
                error: action?.error,
                loading: false
            }
        
        case Constants.LOADING:
            return{
                ...state,
                error: null,
                loading: true
            }

        case Constants.CLEAR:
        default:
            return state
    }
}